var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M720.6,306.4h7.136v3.732H720.6Z",
    transform: "translate(-720.6 -306.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M720.6,0h3.569V8.03H720.6Z",
    transform: "translate(-720.6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M975,0h3.569V8.03H975Z",
    transform: "translate(-975)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M720.6,470.3h3.569v5.028H720.6Z",
    transform: "translate(-720.6 -470.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M975,470.3h3.57v5.028H975Z",
    transform: "translate(-975 -470.3)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eth_s",
    transform: "translate(1929 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(-1929 10364)",
    fill: "#edeff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ethereum",
    transform: "translate(-1925.567 10365.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(0 4.298)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M724.169,306.4l-3.569,1.623,3.569,2.108,3.567-2.108Z",
    transform: "translate(-720.6 -306.4)",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(0)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M720.6,5.921l3.569,2.108V0Z",
    transform: "translate(-720.6)",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(3.569)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M975,0V8.03l3.567-2.108Z",
    transform: "translate(-975)",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(0 6.598)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M720.6,470.3l3.569,5.028v-2.919Z",
    transform: "translate(-720.6 -470.3)",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(3.569 6.598)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M975,472.408v2.919l3.57-5.028Z",
    transform: "translate(-975 -470.3)",
    fill: "#010101"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthS);
export default __webpack_public_path__ + "static/media/eth_s.ddd177bf2aa9832c94de5687267aecce.svg";
export { ForwardRef as ReactComponent };